import React, { Fragment } from 'react'

import { useMediaQueries } from 'hooks'

import { Typo } from 'components/_old/Typo/Typo'
import Width from 'components/_old/Width/Width'

import { Paper } from 'components/atoms/Paper'
import { Typography } from 'components/atoms/Typography'

import { TwoFactorSetupLayout } from '../TwoFactorSetupLayout'

import { RecoveryMethods } from './RecoveryMethods'

const RecoveryMethodStep = (): React.ReactElement => {
  const { desktop } = useMediaQueries()

  const content = (
    <Fragment>
      <Typography size={desktop ? 32 : 24} weight="semibold" lineHeight="small" align="center">
        <Typo>Choose recovery method</Typo>
      </Typography>
      <Paper top={8}>
        <Typography size={14} align="center">
          <Typo>
            If push notifications fail, select another two-factor authentication method to regain access to your
            account.
          </Typo>
        </Typography>
      </Paper>
      <Paper top={56}>
        <Width size={28} center>
          <RecoveryMethods />
        </Width>
      </Paper>
    </Fragment>
  )

  return (
    <TwoFactorSetupLayout>
      <Paper top={40}>
        <Width size={45} center>
          {content}
        </Width>
      </Paper>
    </TwoFactorSetupLayout>
  )
}

export { RecoveryMethodStep }
